import { h } from 'preact';

import { withHomeEntBehavior } from 'components/editor/movies/homeEnt/homeEnt';
import FocusWatchPageEditor from 'components/editor/movies/watch/watchFocus';

import s from 'components/editor/movies/homeEnt/homeEntFocus.sss';

export default class FocusHomeEntEditor extends withHomeEntBehavior(FocusWatchPageEditor) {
	s = s; // Styling will only be assigned in the final implementation (i.e. homeEntFocus.js)

	renderTopLinks() {
		return null; // No top links for homeEnt
	}
}